/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import {
  isAdminAuthenticated,
  isClientAuthenticated,
  isSystemAuthenticated,
} from '../utils/jwtUtil';

export const RestrictSystemRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isSystemAuthenticated() ? (
        <Redirect
          to={{
            pathname: `/system/dashboard`,
            state: { from: props.location },
          }}
        />
      ) : (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }
  />
);

export const RestrictAdminRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAdminAuthenticated() ? (
        <Redirect
          to={{
            pathname: `/admin/dashboard`,
            state: { from: props.location },
          }}
        />
      ) : (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }
  />
);

export const RestrictClientRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isClientAuthenticated() ? (
        <Redirect
          to={{
            pathname: `/client/dashboard`,
            state: { from: props.location },
          }}
        />
      ) : (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }
  />
);
